<template>
    <el-dialog
        title="匹配支付订单"
        width="1100px"
        :visible="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose"
        :custom-class="'matchPaymentOrderDialog'"
        >
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :searchTotalTitle="config.searchTotalTitle"
            :currentPage="searchParams.pageNo"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            searchId="matchPaymentOrderQuery"
            pageID="matchPaymentOrder"
        >
            <div slot="page-module-btn">
                <el-button
                    v-has="''"
                    type="primary"
                    :disabled="!this.selected.length"
                    @click="handleConfirm"
                    >确定</el-button
                >
            </div>
        </m-pane>
    </el-dialog>
</template>
<script>
import mPane from '@/components/otpPanel';
import { matchPaymentOrderConfig } from './config.js';
import { queryPage, queryCount } from '@/modules/transport/otp/api/driverExpenseSplit.js';
import lodash from 'lodash';
export default {
    name: 'MatchPaymentOrder',
    components: {
        mPane
    },
    props: {
        componentData: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            config: matchPaymentOrderConfig,
            loading: false,
            totalData: [],
            pageTotal: 0,
            searchParams: {
                pageSize: 10,
                pageNo: 1,
                param: {}
            },
            rowData: {},
            selected: []
        };
    },
    methods: {
        /**
         * @description 查询条件变化触发事件
         * @param {Object} data 查询条件
         */
        searchChange (data) {
            // 格式化查询条件
            const _searchData = this.formatSearchData(data);
            this.searchParams = this.getSearchData(_searchData);
            this.getList();
        },
        formatSearchData (data) {
            const params = lodash.cloneDeep(data);
            if (params.carrierName) {
                params.carrierNameList = params.carrierName.length ? params.carrierName.split(',') : [];
                params.carrierCodeList = params.carrierCode.length ? params.carrierCode.split(',') : [];
            }
            if (params.driver) {
                params.driverList = params.driver.length ? params.driver.split(',') : [];
            }
            delete params.carrierName;
            delete params.carrierCode;
            delete params.driver;
            return params;
        },
        /**
         * @description 获取列表数据
         * @param {object} 查询条件
         * @return {list} 列表数据
         */
        getList () {
            this.loading = true;
            this.queryCount();
            queryPage(this.searchParams)
                .then((res) => {
                    if (res && +res.code === 0) {
                        this.totalData = res.data.list || [];
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        getSearchData (data) {
            const _searchData = {
                ...this.searchParams,
                pageNo: 1,
                param: {
                    ...data
                }
            };
            return _searchData;
        },
        queryCount () {
            queryCount(this.searchParams.param)
                .then((res) => {
                    if (res && +res.code === 0) {
                        this.pageTotal = res.data || 0;
                    }
                })
                .catch(() => { });
        },
        handleConfirm () {
            if (this.selected.length > 1) {
                return this.$message.warning('匹配支付订单仅支持单选订单，请重新选择');
            }
        },
        beforeClose () {
            this.$emit('update:matchPaymentOrderDialogShow', false);
        },
        // 选中表格行
        selectChange (data) {
            this.selected = data;
        },
        // 切换当前页数
        pageChange (pageNo) {
            this.searchParams.pageNo = pageNo;
            this.getList();
        },
        // 切换分页显示条数
        sizeChange (pageSize) {
            this.searchParams.pageNo = 1;
            this.searchParams.pageSize = pageSize;
            this.getList();
        }
    }
};
</script>

<style lang="less">
.matchPaymentOrderDialog {
    height: 600px;
    overflow: auto;

    .mPane3-back-up .el-table {
        height: 430px !important;
    }
}
</style>
